<template>
    <div class="layout" :class="{'layout-hide-text': spanLeft < 4}">
        <Row type="flex">
            <i-col :span="spanLeft" class="layout-menu-left" :style="{minHeight:leftHeight}">
                <Menu active-name="1" theme="dark" width="auto" @on-select="MenuClick">
                    <div class="layout-logo-left"></div>
                    <Menu-item name="/home">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">首页</span>
                    </Menu-item>
                    <Submenu name="项目管理">
                        <template slot="title">
                            <Icon type="ios-keypad" :size="iconSize"></Icon>
                            <span class="layout-text">项目管理</span>
                        </template>
		                <Menu-item name="/projectList">项目管理</Menu-item>
                        <Menu-item name="/weekList">周计划</Menu-item>
                        <Menu-item name="/weekReportList">周计划报表</Menu-item>
                    </Submenu>
                    <!-- <Menu-item name="/projectList">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">项目管理</span>
                    </Menu-item> -->
                    <Menu-item name="/templateList" v-show="type!=1 && type!=2">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">模板管理</span>
                    </Menu-item>
                    <Menu-item name="/store" v-show="type!=1 && type!=2">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">门店管理</span>
                    </Menu-item>
                    <Menu-item name="/pushNews" v-show="type!=2">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">消息管理</span>
                    </Menu-item>
                    <Menu-item name="/Right" v-show="type!=2">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">用户管理</span>
                    </Menu-item>
                    <Menu-item name="/rightsApp" v-show="type!=2">
                        <Icon type="ios-navigate" :size="iconSize"></Icon>
                        <span class="layout-text">app用户管理</span>
                    </Menu-item>
                </Menu>
            </i-col>
            <i-col :span="spanRight">
                <div class="layout-header">
                    <i-button type="text" @click="toggleClick">
                        <Icon type="navicon" size="32"></Icon>
                    </i-button>
                    <div class="clearfix fr username">
                        <p class="fl">{{name}}</p>
                        <i-button class="fl" type="text" @click="logoutShow=true">
                            <Icon type="log-out" size="20"></Icon>
                        </i-button>
                    </div>
                </div>
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <Breadcrumb-item v-for="item in $route.matched" :key="item.path">{{item.name}}</Breadcrumb-item>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <router-view></router-view>
                        <Spin size="large" fix v-if="loadingShow"></Spin>
                    </div>
                </div>
                <div class="layout-copy">
                    2017.8.31 &copy; xiangpai
                </div>
            </i-col>
        </Row>
        <el-dialog title="退出登录" :visible.sync="logoutShow">
            <p>确认要退出登录吗？</p>
            <div slot="footer" class="dialog-footer">
                <Button @click="logoutShow=false">取 消</Button>
                <Button type="primary" @click="logoutFn">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                name:localStorage.name,
                type:localStorage.type,
                routerItem:[
                   {
                        name:'消息管理',
                        item:[
                            {
                                name:'消息推送',
                                link:'/pushNews'
                            }
                        ]
                    }
                ],
                spanLeft: 4,
                spanRight: 20,
                leftHeight: null,
                logoutShow:false
            }
        },
        computed: {
            iconSize () {
                return this.spanLeft === 5 ? 14 : 24;
            },
            loadingShow () {
                return this.$store.state.loadingShow;
            },
        },
        created(){
        	this.leftHeightFn();
        	window.addEventListener('resize',this.leftHeightFn);
        },
        methods: {
            logoutFn(){   //退出登陆
                var _this=this;
                this.$http.get('/web/login/logout').then(function(res){
                    if(res.success){
                        _this.$Notice.success({
                            title: '退出登录',
                            desc: res.message
                        });
                        _this.$router.push({path:'/login'});
                    }else{
                        _this.$Notice.error({
                            title: '退出登录',
                            desc: res.message,
                        });
                    }
                }).catch(function(res){
                    _this.$Notice.error({
                        title: '退出登录',
                        desc: '数据传输失败',
                    });
                })
            },
            MenuClick(res){ //导航跳转
                this.$router.push({path:res});
            },
        	leftHeightFn () {	//可视区高度改变
        		var H=document.documentElement.clientHeight||document.body.clientHeight;
        		this.leftHeight=(H-2) +'px';
        	},
            toggleClick () {	//列表栏切换
                if (this.spanLeft === 4) {
                    this.spanLeft = 2;
                    this.spanRight = 22;
                } else {
                    this.spanLeft = 4;
                    this.spanRight = 20;
                }
            }
        }
    }
</script>
<style scoped>
    .username i{
        margin-top:7px;
    }
    .layout{
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-breadcrumb{
        padding: 10px 15px 0;
    }
    .layout-content{
        min-height:600px;
        margin: 15px;
        overflow: hidden;
        background: #fff;
        border-radius: 4px;
        padding:20px;
    }
    .layout-content-main{
        padding: 10px;
    }
    .layout-copy{
        text-align: center;
        padding: 10px 0 20px;
        color: #9ea7b4;
    }
    .layout-menu-left{
        background: #464c5b;
    }
    .layout-header{
        line-height:46px;
        height: 60px;
        background: #fff;
        position:relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .layout-header .out{
        position:absolute;
        right:0;
    }
    .layout-header p{
        line-height:;
    }
    .layout-logo-left{
        width: 90%;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;
    }
    .layout-ceiling-main a{
        color: #9ba7b5;
    }
    .layout-hide-text .layout-text{
        display: none;
    }
    .ivu-col{
        transition: width .2s ease-in-out;
    }

    /*a和hover*/
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) a, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu) a{
        color: #2d8cf0;
    }
    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item a, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title a{
        color: rgba(255,255,255,.7);
    }


    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active a, .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover a{
        border-right: none;
        color: #fff;
        background: #2d8cf0!important;
    }

    .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover a{
        color: #fff;
        background: 0 0!important;
    }
</style>


// WEBPACK FOOTER //
// src/components/content.vue